function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 41,
  height: 26,
  fill: "url(#headliner)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
  id: "headliner",
  patternContentUnits: "objectBoundingBox",
  width: 1,
  height: 1
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#image0Headliner",
  transform: "translate(-0.00203252) scale(0.0132114 0.0208333)"
})), /*#__PURE__*/React.createElement("image", {
  id: "image0Headliner",
  width: 76,
  height: 48,
  xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAAAwCAYAAAC7d5yRAAABAElEQVRoQ+3asQ3CMBRF0e9RaBD70McFjMAWbJFNmIM+I9B+RCSUMr5OZemmfj+Kj56iyHGZpiljvOs9z/O557FrrY/MfPbM/maKYIxOMOZlw6CXYILtCPjShxURTLAmAb/Dmpi2kGCCQQEYt2GCQQEYt2GCQQEYt2GCQQEY/0TEC87846eIuHTODrtb0bvew3OjbiAeXnjvDQSDcoIJBgVg3IYJBgVg3IYJBgVg3IYJBgVgfNSGLRFxh2td46WUa2beembXeQ+jMDrBmJcNg16CCbYj4NkKWBHBBGsS8K9RE9MWEkwwKADjNkwwKADjNkwwKADjNkwwKADjNmwUsC+3Q4PwoTeCTwAAAABJRU5ErkJggg=="
}));

var SvgHeadliner = function SvgHeadliner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 26,
    viewBox: "0 0 41 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeadliner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/headliner.6503b09e.svg";
export { ForwardRef as ReactComponent };